An array of human readable descriptions of the certification.

This can contain multiple descriptions from two different sources:

1. Free text descriptions provided by the candidate.
2. Human readable descriptions automatically generated from SEEK's internal structured data.
